import React from 'react';
import { useLoaderData, Link } from 'react-router-dom';
import { getPublicMaterialAsset } from '../../../data/loca/tools';
import { toYoutubeEmbedUrl } from '../../../services/toolAssets';

export async function loader({ params }) {
    const asset = await getPublicMaterialAsset(params.customUrl, params.assetType);
    return { asset, customUrl: params.customUrl };
}

export default function AssetPublic() {
    const { asset, customUrl } = useLoaderData();

    if (!asset) {
        return <div><h1>Asset introuvable</h1></div>;
    }

    return (
        <div className="publicRental">
            <h1>{asset.title}</h1>
            {asset.description && <p>{asset.description}</p>}
            {asset.assetType === 'video' ? (
                <iframe title={asset.title} width="560" height="315" src={toYoutubeEmbedUrl(asset.youtubeUrl)} allowFullScreen></iframe>
            ) : (
                <a href={asset.fileData} download={asset.fileName || `${asset.title}.pdf`}>Télécharger la notice</a>
            )}
            <p><Link to={`/outil/${customUrl}`}>Voir la fiche matériel</Link></p>
        </div>
    );
}
